import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Pilot = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0482 19.4249C9.9906 19.4249 8.72695 18.8149 7.95926 17.8746C7.17285 16.9114 6.81922 15.4969 6.81922 13.7167H5.67273C5.67273 15.6158 6.04438 17.3421 7.07116 18.5997C8.11665 19.8803 9.7541 20.5714 12.0482 20.5714C14.3432 20.5714 15.9134 19.8786 16.8799 18.5793C17.8187 17.3173 18.1013 15.5919 18.1013 13.7167H16.9548C16.9548 15.5209 16.6733 16.9361 15.96 17.895C15.2745 18.8166 14.1048 19.4249 12.0482 19.4249Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.6665 16.99C7.80936 15.9709 10.476 15.8435 11.9998 15.8435C13.9046 15.8435 15.8094 15.9709 16.9522 16.99",
      stroke: color,
      strokeWidth: "0.764329"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.1785 13.7415H6.47699C5.88216 13.7415 5.32957 13.4341 5.01586 12.9288L4.43952 12.0003C3.97328 11.2492 4.15247 10.2669 4.8539 9.72882L9.62161 6.07133C9.92192 5.84094 10.2899 5.71607 10.6684 5.71607H13.1442C13.5146 5.71607 13.8751 5.83564 14.172 6.05698L18.9625 9.62778C19.7238 10.1953 19.8811 11.2724 19.3139 12.0339L18.5577 13.0491C18.2331 13.4848 17.7218 13.7415 17.1785 13.7415Z",
      stroke: color,
      strokeWidth: "1.14649"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.95166 10.2735C8.95166 10.2735 9.02512 9.69722 9.35782 9.2549C9.5609 8.9849 10.292 8.76596 10.7794 9.2549C11.2668 9.74384 11.7948 10.4785 11.9979 10.818C12.3885 10.1839 12.6598 9.92322 13.2163 9.2549C13.4194 8.9849 14.2902 8.78213 14.6379 9.2549C15.1073 9.89319 15.044 10.0031 15.044 10.4106",
      stroke: color,
      strokeWidth: "0.814903"
    })]
  });
};
export { Pilot };